export default {
    participant: 'participant',
    invited: 'Invited',
    empty: 'no Ps.',
    participantCount: '{{count}} Ps.',
    selectedFirmsAreApplicants: 'All selected companies\nhave already been invited or\nare on this platform',
    selectedFirmAreApplicants: 'The selected company has already been invited to this platform',
    lackOfRights: 'Your contact doesn\'t have enough rights to be invited to this platform',
    invitedFirmsCount: {
        zero: '{{count}} companies have already been invited to the platform.',
        one: '{{count}} company has already been invited to the platform.',
        few: '{{count}} companies have already been invited to the platform.',
        many: '{{count}} companies have already been invited to the platform.',
        other: '{{count}} companies have already been invited to the platform.'
    },
    firmsToBeInvitedCount: 'We\'ll invite {{count}} {{firmPlural}}'
};
